import {createEntityService} from 'utils/createEntityService';
import {ProgramCard} from '../types/programCard';

export const ProgramCardsService = createEntityService<ProgramCard>({
  baseUrl: 'api/v1/program_cards',
  entityName: 'programCard',
});
